<body class="ltr main-body leftmenu">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="ElectiveMarksForm">
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm add-form">
                        <div class="col-lg-12 col-md-12">
                            <div class="card custom-card">
                                <div class="card-body pb-0">
                                    <div class="col-md-12 prpl">
                                        <div class="row align-items-center">
                                            <div class="col-md-4 prpl">
                                                <div class="d-flex align-items-center">
                                                    <img alt="Logo" src="../../assets/img/attendance.png"
                                                        class="mh-45px pb-2">
                                                    <p class="mb-1">
                                                        <span class="main-content-label"><b>Student Elective
                                                                Subject Entry</b></span><br>
                                                        <span class="text-muted card-sub-title mb-0">List Of Student
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                            <!-- <div class="col-md-8 d-flex align-items-center justify-content-end">
                                                <div style="min-width: 320px;" class="mr-3">
                                                    <mat-form-field appearance="outline" class="w-100">
                                                        <mat-label>Select Colleges for Report</mat-label>
                                                        <mat-select #reportCollegeSelect
                                                            [ngModel]="selectedReportColleges"
                                                            (ngModelChange)="onReportCollegeSelect($event)"
                                                            [ngModelOptions]="{standalone: true}"
                                                            multiple>
                                                            <mat-select-filter *ngIf="reportCollegeSelect.focused"
                                                                [placeholder]="'Filter Colleges'"
                                                                [displayMember]="'CgName'"
                                                                [array]="reportCollegeList"
                                                                (filteredReturn)="filteredReportCollegeList =$event">
                                                            </mat-select-filter>
                                                            <mat-option (click)="selectAllReportColleges()"
                                                                [value]="'selectAll'"
                                                                [class.selected]="isAllReportSelected()">
                                                                <strong>Select Colleges</strong>
                                                            </mat-option>
                                                            <mat-option *ngFor="let item of filteredReportCollegeList"
                                                                [value]="item.CgCode">
                                                                {{ item.CgCode }} - {{ item.CgName }}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                                <button type="button"
                                                        class="btn btn-primary btn-lg px-4"
                                                        (click)="downloadElectiveReport()"
                                                        [disabled]="isDownloading || !isReportDownloadReady()">
                                                    <span *ngIf="!isDownloading">
                                                        <i class="fas fa-download mr-2"></i>
                                                        Preview Report
                                                    </span>
                                                    <span *ngIf="isDownloading">
                                                        <i class="fas fa-spinner fa-spin mr-2"></i>
                                                        Downloading...
                                                    </span>
                                                </button>
                                            </div> -->
                                        </div>

                                        <hr class="mt-2">
                                        <div class="row clearfix mt-2">
                                            <div class="col-sm-2">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Session</mat-label>
                                                    <mat-select #select232 placeholder="Session" class="colorblack"
                                                        formControlName="SessionId">
                                                        <mat-select-filter *ngIf="select232.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'SnName'"
                                                            [array]="sessionList"
                                                            (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                                        <mat-option *ngFor="let item of SessionFilterList"
                                                            [value]="item.SnNo" (click)="getCourse(item)">
                                                            {{item.SnName}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error
                                                        *ngIf="ElectiveMarksForm.get('SessionId').hasError('required')">
                                                        Session is required
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-sm-2">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Course</mat-label>
                                                    <mat-select #select55 class="colorblack" formControlName="course">
                                                        <mat-select-filter *ngIf="select55.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'CoName'"
                                                            [array]="CourseList"
                                                            (filteredReturn)="filteredListCourse =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredListCourse"
                                                            [value]="item.CoCode" (click)="getCollege(item)">
                                                            {{item.CoCode}} - {{item.CoName}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error
                                                        *ngIf="ElectiveMarksForm.get('course').hasError('required')">
                                                        Course is required
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-sm-2">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>College</mat-label>
                                                    <mat-select #select23 formControlName="college"
                                                        [displayMember]="'CgName'">
                                                        <mat-select-filter *ngIf="select23.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'CgName'"
                                                            [array]="collegeList"
                                                            (filteredReturn)="filteredCollegeList =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredCollegeList"
                                                            [value]="item.CgCode">
                                                            {{item.CgCode}} - {{item.CgName}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error
                                                        *ngIf="ElectiveMarksForm.get('college').hasError('required')">
                                                        College is required
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-sm-2">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Exam</mat-label>
                                                    <mat-select #select2398 placeholder="Exam" formControlName="EmId">
                                                        <mat-select-filter *ngIf="select2398.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'EmName'"
                                                            [array]="examList"
                                                            (filteredReturn)="filteredListExam =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredListExam"
                                                            [value]="item.EmId" (click)="getSubject(item)">
                                                            {{item.EmCoCode}}-{{item.EmName}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error *ngIf="ElectiveMarksForm.get('EmId').hasError('required')">
                                                        Exam is required
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-sm-2" *ngIf="isBranch">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Branch</mat-label>
                                                    <mat-select #select23 placeholder="Branch" formControlName="Branch">
                                                        <mat-select-filter *ngIf="select23.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'EmName'"
                                                            [array]="BranchList"
                                                            (filteredReturn)="filteredListBranch =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredListBranch"
                                                            [value]="item.StrId" (click)="getStr(item)">
                                                            {{item.StrName}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-sm-2">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Subject</mat-label>
                                                    <mat-select #select2345 placeholder="Subject"
                                                        formControlName="EsParentId">
                                                        <mat-select-filter *ngIf="select2345.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'EsName'"
                                                            [array]="subjectList"
                                                            (filteredReturn)="filteredsubjectList =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredsubjectList"
                                                            [value]="item.EsId" (click)="subjectClick(item)">
                                                            {{item.EsCode}}-{{item.EsName}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error
                                                        *ngIf="ElectiveMarksForm.get('EsParentId').hasError('required')">
                                                        Subject is required
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <hr class="mt-2">
                                        <div class="row align-items-center">
                                            <div *ngIf="Table" class="col-sm-9">
                                                <div *ngIf="message; else cut" class="mb-3">
                                                    <p style="color: green;"><b>{{message}}</b></p>
                                                </div>
                                                <ng-template #cut>
                                                    <div class="mb-3">
                                                        <p style="color: red;"><b>{{closeMessage}}</b></p>
                                                    </div>
                                                </ng-template>
                                            </div>
                                            <div *ngIf="Table" class="col-sm-3" [formGroup]="ElectiveMarksForm">
                                                <mat-form-field appearance="outline" class="w-100">
                                                    <mat-label>Search</mat-label>
                                                    <input class="color" matInput placeholder="Search"
                                                        (keyup)="keypress()" formControlName="SearchString">
                                                    <mat-icon matSuffix>search</mat-icon>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div *ngIf="Table" class="table-responsive mt-4">
                                            <div class="container-fluid">
                                                <table class="table table-bordered text-center"
                                                    style="min-width: 600px;">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 50px;">Sr.No</th>
                                                            <th style="min-width: 200px;">Student Name</th>
                                                            <th style="min-width: 120px;">Seat No</th>
                                                            <th style="min-width: 200px;">PRN No</th>
                                                            <th style="min-width: 200px;">Elective Completion Certificate</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody formArrayName="StuArray">
                                                        <tr *ngFor="let studentCtrl of getStuArrayControls(); let i = index"
                                                            [formGroupName]="i">
                                                            <td style="width: 50px; vertical-align: middle;">{{ i + 1 }}
                                                            </td>
                                                            <td style="min-width: 200px; vertical-align: middle; padding: 8px;">
                                                                {{ studentCtrl.get('Name').value }}
                                                            </td>
                                                            <td style="min-width: 120px; vertical-align: middle; padding: 8px;">
                                                                {{ studentCtrl.get('SeatNo').value }}
                                                            </td>
                                                            <td style="min-width: 200px; vertical-align: middle; padding: 8px;">
                                                                {{ studentCtrl.get('PRNNo').value }}
                                                            </td>
                                                            <td style="min-width: 200px; vertical-align: middle; padding: 8px;">
                                                                <mat-radio-group
                                                                    formControlName="ElectiveStatus"
                                                                    [disabled]="isFinalSubmitted">
                                                                    <mat-radio-button class="mr-3" [value]="true">Yes</mat-radio-button>
                                                                    <mat-radio-button [value]="false">No</mat-radio-button>
                                                                </mat-radio-group>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                     <div class="col-sm-12">
    <button type="button"
        class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
        *ngIf="Table && SaveBtn && !isFinalSubmitted && formativeASSCreate"
        [disabled]="saveDisable" (click)="save()">
        <span style="display: contents; align-items: center;">
            <img width="15vh" src="../../assets/img/save.gif" style="margin-right: 7px;">
            Save
        </span>
    </button>
    <button type="button"
        class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
        *ngIf="Table && UpdateBtn && !isFinalSubmitted && formativeASSUpdate"
        [disabled]="updateDisable" (click)="update()">
        <span style="display: contents; align-items: center;">
            <img width="15vh" src="../../assets/img/edit1.gif" style="margin-right: 7px;">
            Update
        </span>
    </button>
    <button type="button"
        class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
        *ngIf="Table && UpdateBtn && !isFinalSubmitted"
        [disabled]="updateDisable" (click)="SaveFinal()">
        <span style="display: contents; align-items: center;">
            <img width="15vh" src="../../assets/img/save.gif" style="margin-right: 7px;">
            Submit Final
        </span>
    </button>
    <div *ngIf="isFinalSubmitted" class="alert alert-info mt-3">
        <i class="fas fa-info-circle"></i> Final submission has been completed. No further changes can be made.
    </div>
</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>